import {CancelTokenSource} from "axios";

export class InternalChatListFilters {
    searchParam: string;
    page: number;
    limit: number;
    listOnlyDeleted: boolean;
    cancelTokenSource?: CancelTokenSource;

    constructor(params: {
        searchParam: string;
        page: number;
        limit: number;
        listOnlyDeleted: boolean;
        cancelTokenSource?: CancelTokenSource;
    }) {
        this.searchParam = params.searchParam;
        this.page = params.page;
        this.limit = params.limit;
        this.listOnlyDeleted = params.listOnlyDeleted;
        this.cancelTokenSource = params.cancelTokenSource;
    }
}
